import React from 'react';
import { Box, RadioGroup, FormControlLabel, Radio } from 'edenred-ui';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ILimitTypeField } from '@epi-models/containers/ManageBenefitGroups';
import { LimitType } from '@epi-constants/benefitTypes';

export const LimitTypeField = ({ name, disabled }: ILimitTypeField) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const {
    field: { value, onChange }
  } = useController({
    name,
    control,
    rules: {
      required: true
    }
  });

  return (
    <Box mt={3}>
      <RadioGroup
        onChange={onChange}
        value={value}
        id={`${name}-limit-type-radio`}
      >
        <Box display="flex" mb={3}>
          <FormControlLabel
            value={LimitType.maximum}
            control={<Radio />}
            label={t(
              'components.manage_benefits.spending_limit_field.labels.maximum'
            )}
            id="choose-maximum-load-radio"
            disabled={disabled}
          />
          <FormControlLabel
            value={LimitType.custom}
            control={<Radio />}
            label={t(
              'components.manage_benefits.spending_limit_field.labels.custom'
            )}
            id="choose-custom-load-radio"
            disabled={disabled}
          />
        </Box>
      </RadioGroup>
    </Box>
  );
};
